import React from "react";
import styles from "./MEmptyCard.module.css";
import { MButton } from "@/components/ui/atoms/MButtons";
import { IconFileOff, IconPlus } from "@tabler/icons-react";

export interface MEmptyCardButtonProps {
  text: string;
  onClick?: () => void;
  variant?: "filled" | "outline";
  leftIcon?: React.ReactNode;
  style?: React.CSSProperties;
  className?: string;
}

export interface MEmptyCardProps {
  icon?: React.ReactNode;
  primaryTitle: string;
  secondaryTitle?: string | React.ReactNode;
  primaryCTA?: MEmptyCardButtonProps;
  secondaryCTA?: MEmptyCardButtonProps;
  className?: string;
}

const MEmptyCard: React.FC<MEmptyCardProps> = ({
  icon,
  primaryTitle,
  secondaryTitle,
  primaryCTA,
  secondaryCTA,
  className,
}) => {
  return (
    <div
      className={[styles.emptyCardOuter, className].filter(Boolean).join(" ")}
    >
      <div className={styles.emptyCardInner}>
        {icon ? (
          React.isValidElement(icon) ? (
            React.cloneElement(icon as any, { className: styles.icon })
          ) : (
            icon
          )
        ) : (
          <IconFileOff className={styles.icon} />
        )}
        <span className={styles.primaryTitle}>{primaryTitle}</span>
        {secondaryTitle && (
          <span className={styles.secondaryTitle}>
            {typeof secondaryTitle === "string"
              ? secondaryTitle.split("\n").map((line, idx) => (
                  <React.Fragment key={idx}>
                    {line}
                    {idx !== secondaryTitle.split("\n").length - 1 && <br />}
                  </React.Fragment>
                ))
              : secondaryTitle}
          </span>
        )}
      </div>
      {(primaryCTA?.text || secondaryCTA?.text) && (
        <div className={styles.actionContainer}>
          {primaryCTA?.text && (
            <MButton
              size="md"
              variant={primaryCTA.variant || "filled"}
              className={primaryCTA.className || "w-full"}
              leftIcon={primaryCTA.leftIcon || <IconPlus />}
              onClick={primaryCTA.onClick}
              style={primaryCTA.style}
            >
              {primaryCTA.text}
            </MButton>
          )}
          {secondaryCTA?.text && (
            <MButton
              size="md"
              variant={secondaryCTA.variant || "outline"}
              className={secondaryCTA.className || "w-full"}
              leftIcon={secondaryCTA.leftIcon || <IconPlus />}
              onClick={secondaryCTA.onClick}
              style={secondaryCTA.style}
            >
              {secondaryCTA.text}
            </MButton>
          )}
        </div>
      )}
    </div>
  );
};

export default MEmptyCard;
